var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-info"},[_c('h2',[_vm._v(_vm._s(_vm.$t(("ProductionProgress.InfoTab." + _vm.title + ".Title"))))]),_c('div',{class:[
            'infos-container',
            { 'order-card': _vm.title === 'Order' },
            { 'operation-card': _vm.title === 'Operation' },
            { 'attributes-card': _vm.title === 'Attributes' },
            { 'observation-card': _vm.title === 'Observation' } ]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }